import React, { useEffect, useState } from 'react';

interface AudioCollectionPlaybackProps {
  utterance?: string;
  audioData?: string;
}

// TODO: have bunch of wrapper components tracking claim time, fullstory, etc.
// see TextCollectionTask and LegacyTasksPage for how submission normally works
const AudioCollectionPlayback = (props: AudioCollectionPlaybackProps) => {
  const [audioResponse, setAudioResponse] = useState('');

  const fetchAudioData = async () => {
    if (!props.audioData) {
      return;
    }
    const res = await fetch(props.audioData);
    const audioBlob = await res.blob();
    const audioSrc = URL.createObjectURL(audioBlob);
    setAudioResponse(audioSrc);
  };

  useEffect(() => {
    fetchAudioData();
  }, []);

  const audioDataElement = <audio controls src={audioResponse} />;

  return (
    <div>
      <p>
        <em>Text to read:</em> {props.utterance || '!! Nothing given !!'}
      </p>
      {audioResponse ? audioDataElement : <p>No response yet.</p>}
    </div>
  );
};

export default AudioCollectionPlayback;
